// assets/pdc-cart-guard.js

(function () {
  'use strict';

  var SPEED_OPTIONS = {
    priority: true,
    rush: true,
    sea: true
  };

  var SPEED_LABELS = {
    standard: 'Standard',
    priority: 'Priority Build',
    rush: 'Rush Build',
    sea: 'Sea Freight'
  };

  function cartUrl(path) {
    var root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    return root.replace(/\/$/, '') + path;
  }

  function getProps(item) {
    return item && item.properties && typeof item.properties === 'object'
      ? Object.assign({}, item.properties)
      : {};
  }

  function normalizeDeliveryOption(value) {
    value = String(value || '').toLowerCase();

    if (value === 'priority' || value.indexOf('priority') !== -1) return 'priority';
    if (value === 'rush' || value.indexOf('rush') !== -1) return 'rush';
    if (value === 'sea' || value.indexOf('sea') !== -1) return 'sea';
    if (value === 'standard' || value.indexOf('standard') !== -1) return 'standard';

    return value;
  }

  function getDeliveryOption(props) {
    return normalizeDeliveryOption(
      props._pdc_delivery_option ||
        props.delivery_option ||
        props.delivery_window ||
        props['Delivery option'] ||
        ''
    );
  }

  function getBookingId(props) {
    return String(props._pdc_booking_id || '');
  }

  function isSpeedUpgrade(item) {
    var props = getProps(item);

    return (
      props._pdc_item_type === 'production_speed_upgrade' ||
      props.type === 'production_speed_upgrade' ||
      props.Type === 'production_speed_upgrade'
    );
  }

  function getUpgradeWindow(props) {
    return normalizeDeliveryOption(
      props._pdc_production_window ||
        props.production_window ||
        props.delivery_option ||
        ''
    );
  }

  function upgradeMatchesMain(upgradeItem, mainItem, wantedWindow) {
    var upgradeProps = getProps(upgradeItem);
    var mainProps = getProps(mainItem);

    if (!isSpeedUpgrade(upgradeItem)) return false;

    var upgradeWindow = getUpgradeWindow(upgradeProps);

    if (upgradeWindow && upgradeWindow !== wantedWindow) {
      return false;
    }

    var mainBookingId = getBookingId(mainProps);
    var upgradeBookingId = getBookingId(upgradeProps);

    if (mainBookingId && upgradeBookingId && mainBookingId === upgradeBookingId) {
      return true;
    }

    var appliedVariant = String(upgradeProps._pdc_upgrade_for || '');

    return appliedVariant && appliedVariant === String(mainItem.variant_id);
  }

  function upgradeHasMain(upgradeItem, cartItems) {
    var upgradeProps = getProps(upgradeItem);
    var upgradeBookingId = getBookingId(upgradeProps);
    var upgradeForVariant = String(upgradeProps._pdc_upgrade_for || '');

    return cartItems.some(function (item) {
      if (item === upgradeItem) return false;
      if (isSpeedUpgrade(item)) return false;

      var props = getProps(item);
      var mainBookingId = getBookingId(props);

      if (upgradeBookingId && mainBookingId && upgradeBookingId === mainBookingId) {
        return true;
      }

      return upgradeForVariant && upgradeForVariant === String(item.variant_id);
    });
  }

  function fetchCart() {
    return fetch(cartUrl('/cart.js'), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (res) {
      return res.json();
    });
  }

  function changeLine(lineNumber, quantity, properties) {
    var payload = {
      line: lineNumber,
      quantity: quantity
    };

    if (properties) {
      payload.properties = properties;
    }

    return fetch(cartUrl('/cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });
  }

  function normalizeCart(options) {
    options = options || {};

    var shouldReload = !!options.reload;

    return fetchCart().then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) return false;

      var changes = [];

      cart.items.forEach(function (item, index) {
        var props = getProps(item);

        if (isSpeedUpgrade(item)) {
          if (!upgradeHasMain(item, cart.items)) {
            changes.push({
              action: 'remove',
              line: index + 1
            });
          }

          return;
        }

        var deliveryOption = getDeliveryOption(props);

        if (!SPEED_OPTIONS[deliveryOption]) return;

        var hasMatchingUpgrade = cart.items.some(function (otherItem) {
          return upgradeMatchesMain(otherItem, item, deliveryOption);
        });

        if (hasMatchingUpgrade) return;

        var standardDate =
          props._pdc_standard_delivery_date_formatted ||
          props._pdc_standard_delivery_date ||
          props.standard_delivery_date ||
          props['Standard delivery date'];

        if (!standardDate) return;

        var newProps = Object.assign({}, props);

        newProps['Delivery option'] = SPEED_LABELS.standard;
        newProps['Delivery date'] = standardDate;

        newProps._pdc_delivery_option = 'standard';
        newProps._pdc_downgraded_from = deliveryOption;
        newProps._pdc_downgraded_from_label =
          SPEED_LABELS[deliveryOption] || deliveryOption;
        newProps._pdc_downgraded_reason =
          'Production Speed Upgrade removed';

        if (newProps.delivery_option !== undefined) {
          newProps.delivery_option = 'standard';
        }

        if (newProps.delivery_date !== undefined) {
          newProps.delivery_date = standardDate;
        }

        changes.push({
          action: 'update',
          line: index + 1,
          quantity: item.quantity,
          properties: newProps
        });
      });

      if (!changes.length) return false;

      changes.sort(function (a, b) {
        return b.line - a.line;
      });

      var chain = Promise.resolve();

      changes.forEach(function (change) {
        chain = chain.then(function () {
          if (change.action === 'remove') {
            return changeLine(change.line, 0);
          }

          return changeLine(change.line, change.quantity, change.properties);
        });
      });

      return chain.then(function () {
        if (shouldReload) {
          window.location.reload();
        }

        return true;
      });
    });
  }

  function isCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  window.pdcNormalizeCartDeliveryDates = normalizeCart;

  document.addEventListener('DOMContentLoaded', function () {
    if (!isCartPage()) return;

    normalizeCart({ reload: true }).catch(function (e) {
      console.warn('PDC cart guard failed:', e);
    });
  });

  document.addEventListener(
    'click',
    function (event) {
      var checkoutButton = event.target.closest(
        'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href*="/checkout"]'
      );

      if (!checkoutButton) return;

      event.preventDefault();
      event.stopPropagation();

      normalizeCart({ reload: false })
        .catch(function (e) {
          console.warn('PDC cart guard before checkout failed:', e);
        })
        .then(function () {
          window.location.href = cartUrl('/checkout');
        });
    },
    true
  );

  var scheduled = null;

  function scheduleNormalize() {
    clearTimeout(scheduled);

    scheduled = setTimeout(function () {
      normalizeCart({ reload: isCartPage() }).catch(function (e) {
        console.warn('PDC scheduled cart guard failed:', e);
      });
    }, 650);
  }

  document.addEventListener(
    'click',
    function (event) {
      var removeOrUpdate = event.target.closest(
        'cart-remove-button, .cart-remove-button, [href*="/cart/change"], [data-cart-remove], [data-remove], button[name="updates[]"], input[name="updates[]"]'
      );

      if (removeOrUpdate) {
        scheduleNormalize();
      }
    },
    true
  );

  if (!window.__pdcCartGuardFetchPatched) {
    window.__pdcCartGuardFetchPatched = true;

    var originalFetch = window.fetch;

    window.fetch = function () {
      var args = arguments;

      return originalFetch.apply(window, args).then(function (response) {
        try {
          var target = args[0];
          var url = typeof target === 'string' ? target : target && target.url;

          if (
            url &&
            (url.indexOf('/cart/change') !== -1 ||
              url.indexOf('/cart/update') !== -1)
          ) {
            scheduleNormalize();
          }
        } catch (e) {}

        return response;
      });
    };
  }
})();